/*eslint-disable*/
import React from 'react'
import { Switch, Route } from 'react-router-dom'

import Home from './pages/home'
import Login from './pages/login'
// import About from "./pages/about"
import Contact from './pages/contact'
import Downloads from './pages/downloads'
import Signup from './pages/signup'
import Privacy from './pages/privacy'
import Ticketing from './pages/ticketing'
import Parcel from './pages/parcel'
import Insurance from './pages/insurance'
import AboutUs from './pages/AboutUs'
import Footer from './components/footer/footer'
import Faq from './pages/faq/Faq'
import ServicesPage from './pages/ServicesPage'
import ServicePage from './pages/ServicePage'
import ScrollToTop from './helpers/scrollToTop'
import EmergencyContact from './pages/EmergencyContact'
import NotFound from './pages/NotFound'

const App = () => {
  return (
    <main>
      <ScrollToTop />
      <Switch>
        <Route exact path='/login'>
          <ScrollToTop />
          <Login />
        </Route>
        <Route exact path='/signup'>
          <ScrollToTop />
          <Signup />
        </Route>
        <Route exact path='/emergency'>
          <ScrollToTop />
          <EmergencyContact />
        </Route>
        <Route exact path='/about'>
          <ScrollToTop />
          <AboutUs />
        </Route>
        <Route exact path='/contact'>
          <Contact />
        </Route>
        {/* <Route exact path='/downloads'>
          <Downloads />
        </Route> */}
        {/* <Route exact path='/platform'>
          <Ticketing />
        </Route> */}
        {/* <Route path="/service">
          <Parcel />
        </Route> */}
        {/* <Route exact path='/plans'>
          <Insurance />
        </Route> */}
        {/* <Route exact path='/resources'>
          <Hiring />
        </Route> */}
        <Route exact path='/privacy'>
          <Privacy />
        </Route>

        <Route exact path='/faq'>
          <Faq />
        </Route>
        <Route exact path='/service'>
          <ServicesPage />
        </Route>
        <Route exact path='/service/:slug'>
          <ScrollToTop />
          <ServicePage />
        </Route>

        <Route exact path='/'>
          <Home />
        </Route>
        <Route component={NotFound} />
      </Switch>
      <Footer />
    </main>
  )
}

export default App
